document.addEventListener("DOMContentLoaded", () => {

    gsap.registerPlugin(ScrollTrigger);
    var elements = document.querySelectorAll('.gsap-container');

    elements.forEach(function (element) {
        var fromLeft = element.classList.contains('gsap-reverse');
        var image = element.querySelector('.gsap-image');
        var title = element.querySelector('.gsap-title');
        var subtitle = element.querySelector('.gsap-subtitle');
        var description = element.querySelectorAll('.gsap-description');


        const elementsToSet = [image, subtitle, title, description];

        elementsToSet.forEach((element) => {
            if (element != null) {
                gsap.set(element, { opacity: 0 });
            }
        });

        var timeline = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: 'bottom bottom+=20%',
                scrub: false
            }
        });

        if (fromLeft) {
            timeline.fromTo(image, { x: '200px' }, { opacity: 1, x: '0', duration: 0.45, delay: 0.2 });
            timeline.fromTo(description, { x: '-200px' }, { opacity: 1, x: '0', duration: 0.45, delay: 0.2 }, '-=0.45');
            timeline.fromTo(title, { x: '-200px' }, { opacity: 1, x: '0', duration: 0.45, delay: 0.2 }, '-=0.45');
            timeline.fromTo(subtitle, { x: '-200px' }, { opacity: 1, x: '0', duration: 0.45, delay: 0.2 }, '-=0.45');
        } else {
            timeline.fromTo(image, { x: '-200px' }, { opacity: 1, x: '0', duration: 0.45, delay: 0.2 });
            timeline.fromTo(description, { x: '200px' }, { opacity: 1, x: '0', duration: 0.45, delay: 0.2 }, '-=0.45');
            timeline.fromTo(title, { x: '200px' }, { opacity: 1, x: '0', duration: 0.45, delay: 0.2 }, '-=0.45');
            timeline.fromTo(subtitle, { x: '200px' }, { opacity: 1, x: '0', duration: 0.45, delay: 0.2 }, '-=0.45');
        }
    });

});
